module.exports = "/shared/img/up-arrow.svg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/up-arrow.svg
// module id = 79
// module chunks = 13